import * as React from 'react';
import BusyType from 'owa-service/lib/contract/BusyType';
import EventCard from 'mini-event-card/lib/components/EventCard';
import getCalendarItemAriaLabelWithoutOnGoingStatus from 'mini-calendar-utils/lib/getCalendarItemAriaLabelWithoutOnGoingStatus';
import { CALENDAR_DAY_VIEW } from 'data/lib/mini-app-constants/commonEventSourceConstants';
import { DayViewEventCardProps } from '../schema/DayViewEventCard.types';
import { FreeBusyConstants } from 'mini-freebusy';
import { getAriaLabelForTimeAndDuration } from 'mini-common-utils/lib/utils/getAriaLabelForTimeAndDuration';
import { getDayViewEventCardStyles } from '../utils/getDayViewEventCardStyles';
import { ReactAppSourceContext } from 'data/lib/utils/ReactAppSourceContext';

const DayViewEventCard = (props: DayViewEventCardProps): JSX.Element => {
    const { item, additionalStyles, itemAriaLabelGetter, hideBorder, hideFreeBusyBar } = props;
    const { Subject, Location, IsEffectiveAllDayEvent, IsCancelled, FreeBusyType } = item;

    const freeBusyValue = IsCancelled ? (FreeBusyConstants.Free as BusyType) : FreeBusyType;

    // Additional styles
    const {
        contentStyles,
        freeBusyBarStyles,
        charmStyles,
        locationStyles,
        titleStyles,
    } = getDayViewEventCardStyles(item, hideBorder, hideFreeBusyBar);

    const ariaLabelForTimeAndDuration: string = getAriaLabelForTimeAndDuration(item);
    const dayViewItemAriaLabel: string = getCalendarItemAriaLabelWithoutOnGoingStatus(
        Subject,
        Location,
        ariaLabelForTimeAndDuration,
        IsEffectiveAllDayEvent,
        false,
        freeBusyValue
    );
    const eventCardAriaLabel = itemAriaLabelGetter
        ? itemAriaLabelGetter(dayViewItemAriaLabel)
        : dayViewItemAriaLabel;

    return (
        <ReactAppSourceContext.Provider value={CALENDAR_DAY_VIEW}>
            <EventCard
                {...props}
                eventCardAriaLabel={eventCardAriaLabel}
                isCharmSmall={!IsEffectiveAllDayEvent}
                additionalStyles={{
                    ...additionalStyles,
                    freeBusyBarStyles: freeBusyBarStyles,
                    charmStyles: charmStyles,
                    titleStyles: titleStyles,
                    locationStyles: locationStyles,
                    contentStyles: contentStyles,
                }}
            />
        </ReactAppSourceContext.Provider>
    );
};

export default DayViewEventCard;
